if (!customElements.get('youtube-grid')) {
  class YoutubeGrid extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handleThumbError = this.handleThumbError.bind(this);
      this.handleModalClose = this.handleModalClose.bind(this);
    }

    connectedCallback() {
      this.modal = document.getElementById(this.dataset.modalId);
      this.playerTarget = this.modal?.querySelector('[data-youtube-grid-player]');

      this.addEventListener('click', this.handleClick);

      this.querySelectorAll('img[data-fallback-src]').forEach((img) => {
        img.addEventListener('error', this.handleThumbError, { once: true });
      });

      if (this.modal) {
        const observer = new MutationObserver(() => {
          if (!this.modal.hasAttribute('open')) this.handleModalClose();
        });
        observer.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
        this.modalObserver = observer;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      if (this.modalObserver) this.modalObserver.disconnect();
    }

    handleClick(evt) {
      const button = evt.target.closest('.js-youtube-grid-open');
      if (!button) return;

      const videoId = button.dataset.videoId;
      if (!videoId || !this.modal || !this.playerTarget) return;

      evt.preventDefault();
      this.openVideo(videoId, button);
    }

    openVideo(videoId, opener) {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&modestbranding=1&playsinline=1`);
      iframe.setAttribute('title', 'YouTube video player');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

      this.playerTarget.innerHTML = '';
      this.playerTarget.appendChild(iframe);

      this.modal.open(opener);
    }

    handleModalClose() {
      if (this.playerTarget) this.playerTarget.innerHTML = '';
    }

    handleThumbError(evt) {
      const img = evt.currentTarget;
      const fallback = img.dataset.fallbackSrc;
      if (fallback && img.src !== fallback) img.src = fallback;
    }
  }

  customElements.define('youtube-grid', YoutubeGrid);
}
